@if (currentDay) {
    <div class="day-page">
    <div class="container day-shell">
        @if (dayInformation != undefined && !error) {
            <div>
                <div class="information">
                    <app-information [dayInformation]="dayInformation"></app-information>
                </div>
                <div class="recommendation-toolbar">
                    <mat-form-field appearance="outline" class="search-text">
                        <mat-label class="search-hint">{{ 'SEARCH.HINT' | translate }}</mat-label>
                        <input [(ngModel)]="searchText" matInput type="text">
                        @if (searchText) {
                            <button (click)="searchText=''" aria-label="Clear" mat-icon-button matSuffix>
                                <mat-icon fontIcon="close">{{ 'GENERAL.DELETE' | translate }}</mat-icon>
                            </button>
                        }
                    </mat-form-field>
                    <div class="day-filter-container">
                        <img #filterBtnRef (click)="openFilterDialog()" alt="{{'DETAILS.FILTER' | translate}}"
                             class="day-filter" src="assets/images/details/filter.svg">
                    </div>
                </div>
                <div class="recommendations">
                    @if (allTasks.length > 0) {
                        <app-recommendation-list
                                [allTasks]="allTasks"
                                [dayInformation]="dayInformation"
                                [searchText]="searchText"></app-recommendation-list>
                    }
                </div>
                <div (click)="scrollToTop()" [ngClass]="{'show-scrollTop': windowScrolled}" class="scroll-to-top">
                    <img alt="{{'SCROLL_UP' | translate}}" class="arrow-up" src="assets/images/day/up-arrow.svg">
                </div>
            </div>
        }
        @if (error) {
            <div>
                <app-error></app-error>
            </div>
        }
    </div>
    </div>
}
